/**
 * The `class` attribute for a part that may end up painting nothing.
 *
 * Some parts carry no recipe of their own — a list cell whose spacing belongs
 * to the list and whose type belongs to the control inside it. They are parts
 * regardless, because the element has to exist for the anatomy to be reachable
 * by a slot, but a caller that passes no class would otherwise leave
 * `class=""` stamped on every row of every listing.
 *
 * Takes the ALREADY-MERGED string rather than the raw values: what merges into
 * it is the part's own business — a recipe and a `className` for some, a
 * `className` alone for others — and only the emptiness of the result is shared.
 *
 * It lives in the primitive tier because both tiers need it and the mechanism
 * carries no commerce meaning, and it is a subpath rather than package-internal
 * for the same reason `@vs-shop/ui/render` is: `@vs-shop/commerce-ui` reaches it
 * across a package boundary, through that package's own
 * `internal/optionalClassName.ts`, which is the line a tenant does not write
 * past.
 */
export const optionalClassName = (resolved: string): string | undefined =>
  resolved === '' ? undefined : resolved;
